import { createReducer, on } from '@ngrx/store';
import { triggerAddAction } from '../Actions/continue-conv.actions';
import {initialState} from '../State/continue-conv.state'

export const continueConvReducer = createReducer(
  initialState,
  on(triggerAddAction, (state, { triggerAddActionFlag }) => ({
    ...state,
    triggerAddActionFlag
  }))
);